<template>
  <div id="text-sidenav" />
</template>

<script>
import WidgetSideNavMixin from '@/components/sidenav/landing/panel/widget/Mixin.js'

export default {
  name: 'TextSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.widget.text-side-nav' },
  mixins: [WidgetSideNavMixin],
}
</script>
